import type { DashboardLayout } from '../types'

const SYSTEM_LAYOUT_ID = 'c3e63241-6958-455d-b3af-9a57407ac922'

export function getSystemLayout(layouts: readonly DashboardLayout[]): DashboardLayout | undefined {
  return (
    layouts.find(({ id }) => id === SYSTEM_LAYOUT_ID) ??
    layouts.find(({ isPreset }) => isPreset) ??
    layouts[0]
  )
}
